import * as Yup from 'yup';

export const UpdateDispatcherImageSchema = Yup.object().shape({
    profilePicture: Yup.mixed<File>()
        .required('An image is required')
        .test(
            'fileSize',
            'File size too large (Max: 15MB)',
            (value: File | null | undefined) => {
                return value ? value.size <= 15 * 1024 * 1024 : true; // 15MB limit
            },
        )
        .test(
            'fileType',
            'Unsupported file format',
            (value: File | null | undefined) => {
                return value
                    ? ['image/jpeg', 'image/png', 'image/gif'].includes(value.type)
                    : true;
            },
        ),

});

export type UpdateDispatcherImageDataType = Yup.InferType<typeof UpdateDispatcherImageSchema>;

type InitialValues = {
    profilePicture: File | null;
};

export const UpdateDispatcherImageInitialValues: InitialValues = {
    profilePicture: null,

};

export interface UpdateDispatcherImageInterface {
    profilePicture: string;

};

